export default __webpack_public_path__ + "static/client_mob-0ae224fd4d521a94f4d82326fb7717bf.png";